export function usePrizeMoney() {
  const config = useRuntimeConfig()
  const localeObject = useI18nLocaleObject()
  const priceFormatter = usePriceFormatter()
  const prizeMoney = config.public.prizeMoney[localeObject.value.currency]
  return computed(() => priceFormatter(+prizeMoney * 100, localeObject.value.currency))
}
